import script from "./ThanqOrganic.vue?vue&type=script&setup=true&lang=js"
export * from "./ThanqOrganic.vue?vue&type=script&setup=true&lang=js"

import "./ThanqOrganic.vue?vue&type=style&index=0&id=43315475&lang=css"

const __exports__ = script;

export default __exports__